module.exports = __webpack_public_path__ + "static/media/profile-press-awi@2x.93f4c002.png";